<template>
  <div class="reply">
    <div class="reply__item" v-for="(reply, index) in replys" :key="reply.comment.commentId">
      <span class="reply__name">{{reply.user.nickName}}</span>
      <!-- 过滤自己回复自己的评论 -->
      <template v-if="reply.repliedUser && (reply.repliedUser.userId !== reply.user.userId)">
        回复
        <span class="reply__name">{{reply.repliedUser.nickName}}</span>
      </template>
      ：{{reply.comment.content}}
      <template v-if="count > replys.length && index === replys.length - 2">
        <div class="reply__more" @click="getAllReplyClickHandler">打开APP，查看完整回复</div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'reply',
    props: {
      replys: Array,
      count: Number,
      getAllReplyLogHandler: Function
    },
    methods: {
      getAllReplyClickHandler(){
        if(this.getAllReplyLogHandler){
          this.getAllReplyLogHandler();
        }
      }
    }
  }
</script>

<style lang="scss">
  .reply {
    font-size: .3rem;
    color: #444;
    line-height: .42rem;
    .reply__item {
      margin-top: .16rem;
    }
    .reply__name {
      color: #00918D;
    }
    .reply__more {
      width: 5.85rem;
      height: .53rem;
      margin: .24rem auto;
      background: #f6f6f6;
      line-height: .53rem;
      font-size: .24rem;
      color: #444;
      text-align: center;
      border-radius: .08rem;
    }
  }
</style>
